<template>
  <span>
    <span
      v-if="valor === null"
      style="display:inline-block; padding: 5px 12px; border-radius: 20px; font-size: 12px; font-weight: 600; background:#f1f2f4; color:#9a9a9a; border:1px dashed #d6d7da;"
    >Indisponível</span>
    <StatusBadge v-else :situacao="valor ? 'confirmada' : 'falhou'" />
  </span>
</template>
<script>
import StatusBadge from "./StatusBadge.vue";

// Estado neutro pra campo que a API ainda nao preenche de verdade (ex:
// email_enviado/whatsapp_enviado, pendentes da issue #493) - nunca chuta
// sim/nao quando o dado nao existe.
export default {
  name: "IndisponivelBadge",
  components: { StatusBadge },
  props: {
    valor: { type: Boolean, default: null }
  }
};
</script>
